import React, { useEffect, useState } from "react";
import { Divider, Row, Col, Radio, Checkbox, message, Image, Input } from "antd";
import { EyeOutlined } from "@ant-design/icons";
import CommonButton from "components/ButtonWidgets/CommonButton/CommonButton";
import { renderTextWithLinks } from "utils/GlobalFunctions";

const StepRegItemWidget = (props) => {
  const { itemInfo, onCheck, onVariableFeeChange, isLast, camperIndex, userData } = props;

  const toAbsoluteUrl = (url) => {
    if (!url) return "";
    if (url.startsWith("http")) return url;
    const base = process.env.REACT_APP_API?.replace("/api/", "") || "";
    const cleanPath = url.startsWith("/") ? url.slice(1) : url;
    return `${base}/${cleanPath}`;
  };

  const imageUrl = toAbsoluteUrl(itemInfo?.image_url);

  const isVariable = (itemInfo.fee_type || "fixed") === "variable";
  const isChecked = userData.camperInfo[camperIndex].sel_reg_id.some(t => t.id === itemInfo.ID);
  const variableAmount = isChecked
    ? (userData.camperInfo[camperIndex].sel_reg_id.find(t => t.id === itemInfo.ID)?.real_fee ?? 0)
    : 0;

  return (
    <div style={{ marginBottom: 10 }}>
      <div style={{ fontWeight: 600 }}>
        <div style={{ marginTop: 10, marginBottom: 5 }}>
          <Row align={"top"} justify="space-between" gutter={[16, 4]}>
            <Col md={13}>
              <Checkbox
                disabled={itemInfo.open == "0"}
                onChange={(e) => {
                  if (onCheck != undefined) {
                    onCheck(camperIndex, itemInfo.ID);
                  }
                }}
                checked={userData.camperInfo[camperIndex].sel_reg_id.some(t => t.id === itemInfo.ID)}
              >
                {itemInfo.registration_text.split("\\n").map((section, secKey) => {
                  return <div key={secKey}>{renderTextWithLinks(section)}</div>;
                })}
              </Checkbox>
            </Col>
            {imageUrl && (
              <Col md={2} style={{ display: "flex", justifyContent: "center" }}>
                <Image
                  width={48}
                  height={36}
                  src={imageUrl}
                  preview={{
                    mask: (
                      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                        <EyeOutlined />
                        <span style={{ fontSize: 12 }}>View</span>
                      </div>
                    ),
                  }}
                  style={{ objectFit: "cover", borderRadius: 4, cursor: "pointer" }}
                />
              </Col>
            )}
            <Col
              md={4}
              style={{ textAlign: "right", marginLeft: 25 }}
            >
              {isVariable ? (
                isChecked ? (
                  <Input
                    type="number"
                    min={0}
                    step="0.01"
                    placeholder="0.00"
                    prefix="$"
                    value={variableAmount > 0 ? variableAmount : ""}
                    style={{ width: 110, textAlign: "right" }}
                    className="common-input"
                    onChange={(e) => {
                      if (onVariableFeeChange) {
                        onVariableFeeChange(camperIndex, itemInfo.ID, parseFloat(e.target.value) || 0);
                      }
                    }}
                    onClick={(e) => e.stopPropagation()}
                  />
                ) : (
                  <span style={{ color: "#888", fontStyle: "italic" }}>Variable</span>
                )
              ) : (
                `$${parseFloat(itemInfo.registration_fee).toFixed(2)}`
              )}
            </Col>
            <Col
              md={5}
              style={{ textAlign: "right", marginRight: 25 }
              }
            >
              Remaining - {parseInt(itemInfo.max_registrations) - parseInt(itemInfo.current_registrations)}
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};
export default StepRegItemWidget;
